try {
    var $ = jQuery;

    $(function () {

        window.addEventListener('load', AOS.refresh);

        $('.lazyload').lazy();

        var sayWho = function () {

            navigator.sayswho = (function () {
                var ua = navigator.userAgent, tem,
                    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                if (/trident/i.test(M[1])) {
                    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                    return 'IE ' + (tem[1] || '');
                }
                if (M[1] === 'Chrome') {
                    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                    if (tem != null)
                        return tem.slice(1).join(' ').replace('OPR', 'Opera');
                }
                M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                if ((tem = ua.match(/version\/(\d+)/i)) != null)
                    M.splice(1, 1, tem[1]);
                return M.join(' ');
            })();
            var who = navigator.sayswho.split(" ");
            var browser = who[0].toLowerCase();
            var version = parseInt(who[1]);

            $("body").addClass(browser);
            $("body").addClass(browser + version);

        };


        function smoothScroll()
        {

            $("a[href*='#']").on('click', function (event) {
                var step= 50;
                // Make sure this.hash has a value before overriding default behavior
                if (this.hash !== "") {
                    // Prevent default anchor click behavior
                    event.preventDefault();

                    // Store hash
                    var hash = this.hash;
                    if(hash === "#dateCarousel") {
                        step= 200;
                    }

                    // Using jQuery's animate() method to add smooth page scroll
                    // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
                    $('html, body').animate({
                        scrollTop: $(hash).offset().top - step
                    }, 800, function () {

                        // Add hash (#) to URL when done scrolling (default click behavior)
                        //window.location.hash = hash;
                    });
                }
            });
        }

        $(document).ready(function(){

            console.log("%cCreated with ❤", 'color:red');

            $(window).scroll(function() {
                if($(window).scrollTop() > 30) {
                    $('#site-navigation').addClass('fixed');
                } else {
                    $('#site-navigation').removeClass('fixed');
                }
            });

            AOS.init();


            var markers = $('.wpgmza_cat_checkbox_item_holder');
            var first = $(markers[0]);
            if(markers.length > 0) {
                markers.each(function () {
                    var label = $(this).find('label');
                    var texte = label.html().toLowerCase().replace(/ /g,"");
                    var logo = $('#'+texte);

                    if(logo !== null) {
                        $(this).css({'background-image': 'url('+logo.val()+')'});
                        $(this).css({'order': ''+logo.data('order')+''});

                        if(logo.data('order') == 1) {
                            first = $(this);
                        } else if (logo.data('order') == 2) {
                            $(this).css({'width': '120px', 'height': '85px'});
                        } else if (logo.data('order') == 3) {
                            $(this).css({'width': '120px', 'height': '85px'});
                        }
                    }
                });


                setTimeout(function () {
                    first.find('input').click();
                },1000);
            }



            $('.wpgmza_checkbox').click(function () {

                var current = $(this);

                $('.wpgmza_checkbox').each(function () {
                    if($(this).prop('id') !== current.prop('id')) {
                        $(this).prop("checked", false);
                        $(this).parent().removeClass('active');
                    }
                });

                if($(this).prop("checked") ){
                    $(this).parent().addClass('active');
                } else {
                    $(this).parent().removeClass('active');
                }
            });



            $('.lien_video').click(function () {
                var order = $(this).data('order');
                var container = $('.container_video-'+order);
                var video = container.find('#video_slider');

                container.addClass('active');
                video[0].play();

                container.find('.close_video').click(function () {
                    container.removeClass('active');
                    video[0].pause();
                    video[0].currentTime = 0;
                    video[0].prop('muted', true);
                });

            });


            $('.navbar-collapse.collapse a').click(function () {
                if($('.navbar-collapse.collapse').hasClass('show')){
                    $(".navbar-toggler").click();
                }
            });

        });

        sayWho();

        if($('body').hasClass('home')) {
            smoothScroll();
        }


    });


}
catch (err) {
    console.log(err);
}